/* eslint-disable @nx/enforce-module-boundaries */
import { useRef, useEffect } from 'react';
import { SmileyIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Emoji } from '@mybridge/ui/emoji';
import { useDisclosure } from '@mybridge/ui/hooks';
import { IconButton } from '@mybridge/ui/icon-button';
import { Box } from '@mybridge/ui/layout';
import { Popover, PopoverContent, PopoverTrigger } from '@mybridge/ui/popover';
import { Tooltip } from '@mybridge/ui/tooltip';
import { Portal } from '@mybridge/ui/portal';

export const ChatEmojiPicker = ({ setText, text, textInputRef,addreaction,selectedMsg, isDisabled = false, editor, ...props }) => {
  const emojiDisc = useDisclosure();
  const { isOpen, onClose } = emojiDisc;
  const { t } = useTranslator();

  const triggerRef = useRef(null);
  const popoverContentRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (!isOpen) return;

      const path =
        (e.composedPath && e.composedPath()) ||
        e.path ||
        (() => {
          const p = [];
          let node = e.target;
          while (node) {
            p.push(node);
            node = node.parentNode;
          }
          return p;
        })();

      if (triggerRef?.current && path.includes(triggerRef.current)) return;
      if (popoverContentRef?.current && path.includes(popoverContentRef.current))
        return;

      onClose();
    };

    document.addEventListener('mouseup', handleDocumentClick);
    return () => {
      document.removeEventListener('mouseup', handleDocumentClick);
    };
  }, [isOpen]);

  const insertAtPos = (value) => {
    if (editor) {
      editor.chain().focus().insertContent(value.native).run();
      return;
    }
    const { current: ref } = textInputRef ?? {};
    if (ref) {
      let startPos = ref.selectionStart;
      let endPos = ref.selectionEnd;
      const text_ =
        ref.value.substring(0, startPos) +
        value.native +
        ref.value.substring(endPos, ref.value.length);
      setText(text_);
    } else {
      addreaction(value?.native,selectedMsg);
    }
  };
  return (
    <>
      <Popover 
        {...emojiDisc} 
        placement="top-start" 
        gutter={10}
        autoFocus={false}
        closeOnBlur={true}
        strategy="fixed"
      >
        <PopoverTrigger>
          <Box ref={triggerRef}>
            <Tooltip rounded={"lg"} variant="round" label={t('myMessages.addEmoji') || "Add Emoji"}>
              <IconButton
                variant="ghost"
                isDisabled={isDisabled}
                icon={
                  <SmileyIcon color={props?.color ? props?.color : '#3D5A80'} />
                }
                {...props}
              />
            </Tooltip>
          </Box>
        </PopoverTrigger>
        {/* <PopoverContent 
          ref={popoverContentRef}
          zIndex={9999} 
          width="auto" 
          maxWidth="none"
          boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
          border="1px solid #E2E8F0"
          borderRadius="8px"
          overflow="visible"
        >
          {emojiDisc.isOpen ? <Emoji onEmojiSelect={insertAtPos} /> : ''}
        </PopoverContent> */}
        <Portal>
          <PopoverContent 
            ref={popoverContentRef}
            zIndex={9999} 
            width="auto" 
            maxWidth="none"
            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
            border="1px solid #E2E8F0"
            borderRadius="8px"
            overflow="visible"
          >
            {emojiDisc.isOpen ? <Emoji onEmojiSelect={insertAtPos} /> : ''}
          </PopoverContent>
        </Portal>
      </Popover>
    </>
  );
};
